import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './design-system/aurora.css';
import { applyTheme } from './design-system/theme';
import { useThemeStore } from './stores/themeStore';

// Apply the persisted (or default) theme immediately on load
applyTheme(useThemeStore.getState().mode);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
